import React from 'react';
import Actions from '../../../components/Actions';
import Search from '../../../components/Search';
import Button from '../../../components/Button';
import FontAwesomeIcon from '../../../components/Icon';
import Checkbox from '../../../components/Checkbox';
import { BulkUpdateServiceRequest } from './BulkUpdateServiceRequest';
import { isRole } from 'src/helpers/permissions';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import './ServiceRequestDashboardActions.scss';
import useWindowSize from 'src/hooks/useWindowSize';

interface IServiceRequestDashboardActionsProps {
  searchString: string;
  onChangeSearchString: (value: string) => void;
  onShowFilterOverlay: () => void;
  filterCount: number;
  disableGroup: boolean;
  onGroup: () => void;
  onBulkStatusUpdate: (status: string) => void;
  showResolved: boolean;
  onShowResolved: () => void;
  onDownload: () => void;
}

export const ServiceRequestDashboardActions = ({
  searchString,
  onChangeSearchString,
  onShowFilterOverlay,
  filterCount,
  disableGroup,
  onGroup,
  onBulkStatusUpdate,
  showResolved,
  onShowResolved,
  onDownload,
}: IServiceRequestDashboardActionsProps) => {
  const user = useSelector(selectAuthenticatedUser);
  const {isMobile} = useWindowSize();
  return (
    <div className="serviceRequestDashboardActionsContainer">
      <Search
        value={searchString}
        onChange={(c) => onChangeSearchString(c.target.value)}
        placeholder="Search..."
        size="small"
        theme={null}
        style={{ margin: '0px' }}
        containerStyle={{ width:'100%', minWidth: '8rem' }}
      />
      <Button
        color="teal"
        label={`Filter ${filterCount > 0 ? `(${filterCount})` : ''}`}
        size="small"
        onClick={onShowFilterOverlay}
        icon={<FontAwesomeIcon glyph="filter" weight="light" size="small" />}
        block={undefined}
        disabled={undefined}
        outlined={undefined}
        outline={undefined}
        weight={undefined}
        children={undefined}
        style={undefined}
        hideLabel={false}
        id="serviceRequestFilterButton"
      />

      <div className="serviceRequestDashboardActionsSpacer"></div>

      <Checkbox
        label={"Show Resolved" + (isMobile ? "" : " Tickets")}
        size="small"
        value={showResolved}
        onChange={() => onShowResolved()}
        containerStyle={{ marginBottom: 0, marginRight: '1rem' }}
        id="serviceRequestShowResolvedCheckbox"
      />
      {!isRole(['Home Owner', 'Realtor', 'Vendor'], user) && (
        <>
          <Button
            color="teal"
            disabled={disableGroup}
            onClick={onGroup}
            label="Group"
            size="small"
            block={undefined}
            outlined={undefined}
            icon={undefined}
            outline={undefined}
            weight={undefined}
            children={undefined}
            style={undefined}
          />
          <BulkUpdateServiceRequest
            disableBulkUpdate={disableGroup}
            onChangeStatus={onBulkStatusUpdate}
            label="UPDATE"
            style={{ marginRight: 0, width: '100%' }}
          />
        </>
      )}
      <div
        onClick={disableGroup ? undefined : onDownload}
        id="serviceRequestDownloadButton"
        style={{
          opacity: disableGroup ? 0.4 : 1,
          cursor: disableGroup ? 'not-allowed' : 'pointer',
          pointerEvents: disableGroup ? 'none' : 'auto',
        }}
      >
        <FontAwesomeIcon glyph="download" weight="regular" size="big" />
      </div>
    </div>
  );
};
